// Flag gating the legacy V2 "support" surface (tickets, members, reservations,
// homes, properties, jobs) as that functionality moves to Mission Control V3.
export const V2_SUPPORT_DEPRECATED_FLAG = 'v2SupportDeprecated'

export const V2_SUPPORT_DEPRECATED_PATH_PREFIXES = [
  '/reservations',
  '/members',
  '/properties',
  '/homes',
  '/tickets',
  '/jobs',
] as const

export const isV2SupportDeprecatedPath = (path: string): boolean =>
  V2_SUPPORT_DEPRECATED_PATH_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`))

// Where users go when they hit a deprecated V2 support route. This is a
// different origin, so react-router (`Navigate`/`useNavigate`/`Link`) can't get
// there — callers must use a full-page browser navigation or a plain anchor.
// Deep links intentionally collapse to the V3 root rather than mapping the
// original path, since V2 and V3 route names are not guaranteed to line up.
//
// Sourced from wrangler.toml (`[vars]` for staging, `[env.production.vars]` for
// production) via vite's `define`, so staging V2 sends users to staging V3
// rather than into production data. `vite.config.ts` treats this as a required
// var and fails a production build if the value still contains "staging".
export const V3_URL = process.env.MISSION_CONTROL_V3_URL ?? ''

/**
 * Leaves the SPA for V3, replacing the current history entry so the back
 * button doesn't return to a V2 route that would only redirect again. Used for
 * route-level redirects.
 */
export const redirectToV3 = (): void => {
  window.location.replace(V3_URL)
}

/**
 * Leaves the SPA for V3, keeping V2 in history so the back button returns
 * here. Used when the user actively clicks something.
 */
export const navigateToV3 = (): void => {
  window.location.assign(V3_URL)
}
